(() => {
  const getDialog = (id) => document.getElementById(id);

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-q974-dialog-open]');
    if (opener) {
      const dialog = getDialog(opener.dataset.q974DialogOpen);
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
        document.documentElement.classList.add('q974-dialog-open');
      }
      return;
    }

    const closer = event.target.closest('[data-q974-dialog-close]');
    if (closer) {
      const dialog = closer.closest('dialog');
      if (dialog) dialog.close();
    }
  });

  document.addEventListener('click', (event) => {
    if (event.target instanceof HTMLDialogElement && event.target.classList.contains('q974-size-guide__dialog')) {
      const rect = event.target.getBoundingClientRect();
      const inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!inside) event.target.close();
    }
  });

  document.addEventListener('close', (event) => {
    if (event.target instanceof HTMLDialogElement && event.target.classList.contains('q974-size-guide__dialog')) {
      document.documentElement.classList.remove('q974-dialog-open');
    }
  }, true);
})();
